import React, { useEffect, useState } from 'react'
import Style from './AssignProductToRestaurantContainer.module.scss'
import Select from "react-select";
import {AssignToSupplierPostApi, getFoodCategoryApi, getRestaurantProductListApi,getSupplierListApi } from '../../../Api/PanelAdminServices';
import { useForm } from 'react-hook-form';
import TableFixedPage from '../../TableFixedPage/TableFixedPage';
import { errorToast, succToast } from '../../../Utils/Toast/Toast';
const AssignProductToRestaurantContainer = () => {
  //////////states part ////////////
  const[suppliers,setSuppliers]=useState([])
  const[productList,setProductList]=useState([])
  const[chooseSupplier,setChooseSupplier]=useState()
  const[chooseProduct,setChooseProduct]=useState()
  const[newCategory,setNewCategory]=useState()
  const[chooseNewCategory,setChooseNewCategory]=useState()
  const[disable,setDisable]=useState(true)
  const[disableOk,setDisableOk]=useState(false)

  ////////////useefect part /////////////
  useEffect(()=>{
    getSuppliers()
    getProductList()
  },[])

  ////// get restaurant list /////////////
  const getSuppliers=async()=>{
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSuppliers(res.suppliers);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  const suppliersFeild=async(id)=>{
    setChooseSupplier(id) 
    /////// get category free list //////////
    getFoodCategoryApi(id.value,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setNewCategory(res.category)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
    setDisable(false)
  }
  let optionsSuppliers =suppliers &&suppliers.filter((val) => val.type === "food")
    .map((item) => {
      return {value: item.id , label: item.name,};
    });
    
  let optionsCategory =newCategory &&newCategory.map((item) => {
    return {value: item.id , label: item.category,};
  });
  
  /////// get product list /////////////
  const getProductList=async()=>{
    getRestaurantProductListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setProductList(res.products);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  let optionsProduct =productList &&productList.map((item) => {
      return {value: item.id , label: item.name,};
    });
    
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  /////// post assign product to restaurant /////////
  const onsubmit=(data)=>{
    setDisableOk(true)
    let info={
      supplier_id:chooseSupplier===undefined?null:chooseSupplier.value,
      category_free:chooseNewCategory===undefined?null:chooseNewCategory.value,
      count:data.count,
      max_count:data.maxCount,
      price:data.price,
      off_price:data.discount,
      product_id:chooseProduct===undefined?null:chooseProduct.value
    }
    AssignToSupplierPostApi(info,res=>{
      if(res.status===1){
        succToast(res.message)
        setDisableOk(false)
      }
      else{
        errorToast("خطایی رخ داده است")
        setDisableOk(false)
      }
    })
  }

  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"اختصاص کالا رستورانی"} />
      <div className={Style.imgHolder}>
        <img src="/Assets/Images/assignProduct/restaurant.svg" alt=""/>
      </div>
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <Select 
          options={optionsSuppliers} 
          className={Style.selectOptionsearch} 
          placeholder={"لیست رستوران"}
          onChange={suppliersFeild}
          />

          <Select 
          options={optionsCategory} 
          className={Style.selectOptionsearch} 
          placeholder={"دسته بندی جدید"}
          onChange={setChooseNewCategory}
          isDisabled={disable}
          />
          <Select 
          className={Style.selectOptionsearch} 
          placeholder={"لیست محصول"}
          options={optionsProduct}
          onChange={setChooseProduct}
          />

          <input 
          className={errors.count ? Style.errorInput :Style.inputPart} 
          placeholder={"تعداد"}
          {...register("count",{required:true})}
          />

          <input 
          className={errors.maxCount ? Style.errorInput :Style.inputPart} 
          placeholder={"حداکثر تعداد"}
          {...register("maxCount",{required:true})}
          />

          <input 
          className={errors.price ? Style.errorInput :Style.inputPart} 
          placeholder={"قیمت"}
          {...register("price",{required:true})}
          />

          <input 
          className={Style.inputPart} 
          placeholder={"قیمت با تخفیف"}
          {...register("discount")}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center",marginTop:"1rem" }}>
          <button className={Style.btnStyle} type={"submit"} disabled={disableOk}>ثبت</button>
        </div>
      </form>
    </div>
  )
}

export default AssignProductToRestaurantContainer